module.exports = __webpack_public_path__ + "static/img/home page banner mobile.0c4425b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home page banner mobile.png
// module id = ehao
// module chunks = 1